import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const ToggleContainer = styled.button`
	border: none;
	border-radius: 4px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 1rem;
	margin-top: 0.5rem;
	position: relative;
	width: 5rem;
	height: 1.5rem;
	overflow: hidden;
	outline: none;
	background: ${props => (props.isActive ? props.theme.account : props.theme.Med_Rust)};
	box-shadow: ${props =>
		props.isActive
			? `inset 7px 7px 15px ` +
			  props.theme.account +
			  ',' +
			  `inset -7px -7px 15px ` +
			  props.theme.account
			: 'inset 7px 7px 15px ' +
			  props.theme.Med_Rust +
			  ',' +
			  'inset -7px -7px 15px ' +
			  props.theme.Med_Rust};
	transition: background 0.3s ease, box-shadow 0.3s ease;

	.toggle-circle {
		height: 1.5rem;
		width: 1.5rem;
		border-radius: 10%;
		background: #e0e0e0;
		transition: transform 0.3s ease;
		transform: ${props => (props.isActive ? 'translateX(3.2rem)' : 'translateX(-0.5rem)')};
	}

	.toggle-label {
		font-size: 0.8rem;
		color: #fff;
		position: absolute;
		transition: opacity 0.3s ease;
	}

	.toggle-label.active {
		left: 0.5rem;
		opacity: ${props => (props.isActive ? 1 : 0)};
	}

	.toggle-label.inactive {
		right: 0.5rem;
		opacity: ${props => (props.isActive ? 0 : 1)};
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 6.1rem;
		height: 1.6rem;
		margin-top: 0.4rem;
		.toggle-circle {
			height: 1.6rem;
			width: 1.6rem;
			transform: ${props => (props.isActive ? 'translateX(4.2rem)' : 'translateX(-0.5rem)')};
		}

		.toggle-label {
			font-size: 0.9rem;
		}
		.toggle-label.active {
			left: 1rem;
		}
		.toggle-label.inactive {
			right: 1rem;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 8rem;
		height: 3rem;
		margin-top: 1rem;
		.toggle-circle {
			height: 3rem;
			width: 3rem;
			transform: ${props => (props.isActive ? 'translateX(4.7rem)' : 'translateX(-0.5rem)')};
		}

		.toggle-label {
			font-size: 0.9rem;
		}
		.toggle-label.active {
			left: 1.1rem;
		}
		.toggle-label.inactive {
			right: 1rem;
		}
	}
`;

export const ToggleTextButton = ({ enabled, onClick }) => {
	const [isActive, setIsActive] = useState(enabled);

	const toggle = () => {
		if (onClick) onClick(!isActive);
	};

	useEffect(() => {
		setIsActive(enabled);
	}, [enabled]);

	return (
		<ToggleContainer isActive={isActive} onClick={toggle}>
			<div className='toggle-circle'></div>
			<span className='toggle-label active body10'>Active</span>
			<span className='toggle-label inactive body10'>Inactive</span>
		</ToggleContainer>
	);
};
